var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"im-container"},[_c('div',{staticClass:"nav"},[_c('div',{staticClass:"top"},[_c('van-sticky',[_c('NavBar',{ref:"navBar",attrs:{"showBack":false,"showRole":_vm.routeType === 'chat',"goBack":_vm.goBack,"title":_vm.routeType === 'chat'
              ? _vm.gameInfo.name.length > 6
                ? _vm.gameInfo.name.slice(0, 6) + '...'
                : _vm.gameInfo.name
              : this.$t('im.留言板')}})],1)],1),_c('Notice',{ref:"nav",attrs:{"top":_vm.noticeTop}})],1),_c('div',{staticClass:"im-inner"},[_c('Im')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }